import { useMutation } from '@tanstack/react-query';
import type { AgentApiCandidateImportRequestsRecord } from '@/types/serializers';

interface BulkCreateCandidatesParams {
  encryptId: string;
  selectedIds: number[];
}

export const useBulkCreateCandidates = () => {
  return useMutation({
    mutationFn: async (params: BulkCreateCandidatesParams) => {
      const { encryptId, selectedIds } = params;

      const response = await fetch(
        `/agent/api/candidate_import_requests/${encryptId}/bulk_create`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token':
              document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content || '',
          },
          body: JSON.stringify({ selected_ids: selectedIds }),
        }
      );

      if (!response.ok) {
        const errorData = await response
          .json()
          .catch(() => ({ message: '取り込みに失敗しました' }));
        throw new Error(errorData.message || '取り込みに失敗しました');
      }

      const data: AgentApiCandidateImportRequestsRecord = await response.json();
      return data;
    },
  });
};
